import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  BoxList,
  FiltersControls,
  Pagination,
  Spinner,
  PrivateComponent,
  ButtonAction,
  Modal,
} from 'components';
import {
  loadYcProjectsCreator,
  setYcProjectsPageCreator,
  setYcProjectsPerPageCreator,
  removeYcProjectCreator,
} from 'store/actionsCreators';
import { isLoading } from 'helpers';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const Running = ({
  projects,
  page,
  pages,
  perPage,
  loading,
  loadProjects,
  setPage,
  setPerPage,
  deleteProject,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [deleteModal, setDeleteModal] = useState(null);

  useEffect(() => {
    setPage(1);
  }, [perPage, setPage]);

  useEffect(() => {
    loadProjects({ status: 'running' });
  }, [perPage, page, loadProjects]);

  return (
    <>
      <FiltersControls
        perPageSelected={perPage}
        perPageOnChange={({ value }) => setPerPage(value)}
      />
      {loading ? <Spinner /> : null}
      {!loading ? (
        <>
          <BoxList
            type="project"
            items={projects}
            alert={t('global.noResultsFound')}
            customRenderActions={({ item }) => (
              <>
                <PrivateComponent
                  permissions={{
                    roles: ['yc_project_manage'],
                  }}
                >
                  <ButtonAction
                    icon="edit"
                    title={t('global.editButton')}
                    verticalviewbreakpoint="xl"
                    onClick={() => history.push(`/yc/project/${item.id}/edit`)}
                  />
                </PrivateComponent>
                <PrivateComponent
                  permissions={{
                    roles: ['yc_project_role_manage'],
                  }}
                >
                  <ButtonAction
                    icon="list"
                    title={t('page.yc.projects.manageRoles')}
                    verticalviewbreakpoint="xl"
                    onClick={() =>
                      history.push({
                        pathname: `/yc/project-roles/${item.id}`,
                        state: { projectName: item.name },
                      })
                    }
                  />
                </PrivateComponent>
                <PrivateComponent
                  permissions={{
                    roles: ['yc_project_manage'],
                  }}
                >
                  <ButtonAction
                    icon="closeCircle"
                    title={t('global.remove')}
                    verticalviewbreakpoint="xl"
                    onClick={() => setDeleteModal(item.id)}
                  />
                </PrivateComponent>
              </>
            )}
          />
          <Pagination styled currentPage={page} totalPages={pages} onChange={setPage} />
        </>
      ) : null}
      <Modal
        heading={t('modals.headings.areYouSure')}
        description={t('page.yc.projects.removeProjectDesc')}
        isOpen={deleteModal}
        confirm={() => {
          deleteProject(deleteModal);
          setDeleteModal(null);
        }}
        cancel={() => setDeleteModal(null)}
      />
    </>
  );
};

Running.propTypes = {
  projects: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  loadProjects: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  setPerPage: PropTypes.func.isRequired,
  deleteProject: PropTypes.func.isRequired,
};

const mapStateToProps = ({ yc, loading }) => ({
  projects: yc.projects.list.items,
  page: yc.projects.list.page,
  pages: yc.projects.list.pages,
  perPage: yc.projects.list.perPage,
  loading: isLoading(loading, 'YC'),
});
const mapDispatchToProps = (dispatch) => ({
  loadProjects: (payload) => dispatch(loadYcProjectsCreator(payload)),
  setPage: (payload) => dispatch(setYcProjectsPageCreator(payload)),
  setPerPage: (payload) => dispatch(setYcProjectsPerPageCreator(payload)),
  deleteProject: (id) => dispatch(removeYcProjectCreator(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Running);
